var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex" }, [
    _c(
      "div",
      { staticClass: "flex justify-between items-start min-w-0 flex-1" },
      [
        _vm.avatar
          ? _c(
              "div",
              { staticClass: "flex items-center" },
              [_vm._t("avatar"), _vm._t("name")],
              2
            )
          : _vm._e(),
        _c("div", { staticClass: "text-lg font-bold text-gray-800" }, [
          _vm._v(_vm._s(_vm.name)),
        ]),
        !_vm.nameonly
          ? _c(
              "div",
              [_c("jb-active-chip", { attrs: { active: _vm.active } })],
              1
            )
          : _vm._e(),
        _vm._t("chip"),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }